

export const larryReviewerReviewHinge = {
  _id: 'larryReviewerReviewHingeId',
  email: 'larry@email.com',
  profileReviewId: 'larryProfileReviewHingeId',
  reviewerProfileId: 'larryReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Larry! This will really help me!',
  profileReviewedFirstName: 'Leon',
}

export const larryReviewerReviewBumble = {
  _id: 'larryReviewerReviewBumbleId',
  email: 'larry@email.com',
  profileReviewId: 'larryProfileReviewBumbleId',
  reviewerProfileId: 'larryReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Larry! This will really help me!',
  profileReviewedFirstName: 'Leon',
}

export const larryReviewerReviewTinder = {
  _id: 'larryReviewerReviewTinderId',
  email: 'larry@email.com',
  profileReviewId: 'larryProfileReviewTinderId',
  reviewerProfileId: 'larryReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Larry! This will really help me!',
  profileReviewedFirstName: 'Leon',
}